import { Component, EventEmitter, Input, OnChanges, OnInit, 
          Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { LOCAL_STORAGE_KEY } from '@core/configs';
import { Mode } from '@core/constants';
import { InputType } from '@core/models/enums';
import { InputParams } from '@core/models/models';
import { LocalStorageService } from '@core/services/common';
import { v4 } from 'uuid';

@Component({
  selector: 'caremoni-textbox',
  templateUrl: './textbox.component.html',
  styleUrl: './textbox.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class TextboxComponent implements OnInit, OnChanges {

  @Input() inputParams: InputParams = new InputParams();
  // input value variables
  @Input() inputValue: any = null;
  @Input() canClear = false;
  @Output() onKeyUp = new EventEmitter<any>();
  @Output() onInput = new EventEmitter<any>();
  @Output() onKeyDown = new EventEmitter<any>();
  @Output() onClick = new EventEmitter<any>();
  @Output() onFocus = new EventEmitter<any>();
  @Output() onFocusOut = new EventEmitter<any>();
  @Output() inputValueChange = new EventEmitter();
  // fires when the TV virtual keyboard is confirmed/closed (native app dispatches 'tv-keyboard-done' on this input)
  @Output() onKeyboardDone = new EventEmitter<any>();

  @Input()  xdpad?: number = -1;
  @Input()  ydpad?: number = -1;
  @Input()  dpad?: number = -1;
  @Input()  tabdpad?: number = -1;
  @Input()  xtabdpad?: number = -1;
  @Input()  ytabdpad?: number = -1;
  @Input()  scaledpad?: number = -1;
  
  showValidateErr: boolean = false;
  inputType: string = 'text';
  inputEdit: boolean = false;
  // char code enter key
  enterKey: number = 13;
  telNum: string = '';
  @Input() inputId: string = '';
  @Input() textCenter: boolean = false;
  constructor(private localStorageService: LocalStorageService) { }

  ngOnInit(): void {
    if (this.inputId === '') {
      this.inputId = v4();
    }
    this.setInputType();
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (let propName in changes) {
      if (propName === 'inputParams') {
        if (this.inputParams.isError === true) {
          this.showValidateErr = true;
        } else {
          this.showValidateErr = false;
        }
      }
    }
  }

  onInputData(event: any) {
    this.onInput.emit(event)
    if (this.inputParams.type == InputType.number) {
      const value = event.target.value;
      if (/^-?\d*$/.test(value) && this.checkValidateInput(this.inputParams.maxLength || 50, value)) {
        this.telNum = value;
      } else {
        event.target.value = this.telNum;
      }
      this.inputValue = this.telNum;
    }
    else {
      this.inputValue = event.currentTarget?.value;
    }
    this.inputValueChange.emit(this.inputValue);
  }

  setInputFocus() {
    let inputElement = document.getElementById(this.inputId);
    if (inputElement !== undefined) {
      inputElement?.focus();
    }
  }

  onKeyUps(event: any) {
    this.onKeyUp.emit(event);
    if (event.keyCode === this.enterKey && event.currentTarget?.value === '') {
      this.showValidateErr = true;
    }
    else {
      this.showValidateErr = false;
    }
    this.inputValue = event.currentTarget?.value;
  }

  // set type for input
  setInputType() {
    if (this.inputParams?.disabled || this.inputParams?.readonly) {
      this.inputParams.placeholder = '';
    }

    switch(this.inputParams?.type) {
      case InputType.number:
        this.inputType = 'number';
        return;
      case InputType.tel:
        this.inputType = 'tel';
        return;
      case InputType.email:
        this.inputType = 'email';
        return;
      case InputType.password:
        this.inputType = 'password';
        return;
      case InputType.text:
      default:
        this.inputType = 'text';
        return;
    }
  }

  onKeyDowns(event: any) {
    this.onKeyDown.emit(event);
    this.inputValue = event.currentTarget?.value;
  }

  onClicks(event: any) {
    this.onClick.emit(event);
  }

  onFocusIn(event: any) {
    this.onFocus.emit(event);
    this.showValidateErr = false;
    this.inputParams.isValidate = this.showValidateErr;
    this.inputValue = event.currentTarget?.value;
  }

  onFocusOutInput(event: any) {
    this.onFocusOut.emit(event);
    this.inputValue = event.currentTarget?.value.trim();
    if (this.inputParams?.maxLength && this.inputParams?.type == InputType.number) {
      this.inputValue = event.currentTarget?.value?.toString().substring(0, this.inputParams.maxLength).trim()
    }
    if (this.inputValue === '') {
      this.showValidateErr = true;
    }
    else if (this.inputParams.isError === true) {
      this.showValidateErr = true;
    }
    else {
      this.showValidateErr = false;
    }
    this.inputParams.isValidate = this.showValidateErr;
  }

  onKeyboardDoneEvent(event: any) {
    const mode = this.localStorageService.getItem(LOCAL_STORAGE_KEY.mode);
    if (mode != Mode.TV) return;
    this.inputValue = event?.detail?.value ?? event?.currentTarget?.value;
    this.onKeyboardDone.emit(this.inputValue);
  }

  clearText() {
    this.inputValue = null
    this.inputValueChange.emit(null)
  }

  empty(value: any) {
    return value === null || value === undefined || value === ''
  }

   /**
    * count byte for string
    */
  checkValidateInput(maxlength: number, event: any) {
    let len = 0;
    let tempstr = event;
    if (tempstr != undefined) {
        for (let i = 0; i < tempstr.length; i++) {
            let code = tempstr.charCodeAt(i);
            if ((code >= 0x0 && code < 0x81) || (code === 0xf8f0) || (code >= 0xff61 && code < 0xffa0) || (code >= 0xf8f1 && code < 0xf8f4)) {
                len += 1;
            } else {
                len += 2;
            }
        }
    }
    if (len <= maxlength) {
        return true;
    }
    else {
        return false;
    }
  }
}
